// extracted by mini-css-extract-plugin
module.exports = {"siteLayoutBackground":"ProductosTabLayout_siteLayoutBackground__1b7p_"};